/**
 * Created by Alican Köker on 2018-03-20.
 */

export class WildNudgeStrings {
    public static FS_YOU_WON_TEXT:string = "You won";
    public static FS_SPINS_PLAYED:string = "Spins played: ";
}